export function calculateCorrectedPressure(
  differentialPressure,
  observedGPM,
  ratedFlow,
  filterMfg
) {
  if (observedGPM === null) {
    return null;
  }

  var percentRatedFlowRate = (observedGPM / ratedFlow) * 100;
  if (percentRatedFlowRate > 100) {
    return null;
  }
  if (
    (typeof filterMfg === "string" || filterMfg instanceof String) &&
    filterMfg.toLowerCase() === "facet"
  ) {
    var actualDP;
    actualDP =
      differentialPressure *
      (2.237 * Math.pow(2.718, -0.00896 * percentRatedFlowRate) +
        9.638 * Math.pow(2.718, -0.04719 * percentRatedFlowRate));
    if (actualDP < 16) {
      actualDP =
        differentialPressure *
        (2.237 * Math.pow(2.718, -0.00896 * percentRatedFlowRate) +
          9.638 * Math.pow(2.718, -0.04719 * percentRatedFlowRate));
    }
    return actualDP;
  } else {
    return (
      differentialPressure *
      (2.237 * Math.pow(2.718, -0.00896 * percentRatedFlowRate) +
        9.638 * Math.pow(2.718, -0.04719 * percentRatedFlowRate))
    );
  }
}

export function calculateAMPS(minivolts) {
  return (minivolts * 0.2).toFixed(2);
}

export function findCheck(option, check_id) {
  let check = null;
  if (option.options && option.options.length) {
    for (const inner_option of option.options) {
      if (inner_option.id === check_id) {
        check = inner_option;
        return check;
      }

      check = findCheck(inner_option, check_id);
      if (check) return check;
    }
  }

  if (option.children && option.children.length) {
    for (const child of option.children) {
      if (child.id === check_id) {
        check = child;
        return check;
      }

      check = findCheck(child, check_id);
      if (check) return check;
    }
  }

  return check;
}

export function setTimeAndUser(option, user) {
  if (option.options && option.options.length) {
    for (const inner_option of option.options) {
      if (inner_option.photo && !inner_option.time) {
        inner_option.time = formatDate();
        inner_option.user = user;
        inner_option.open = 1;
      }

      setTimeAndUser(inner_option, user);
    }
  }

  if (option.children && option.children.length) {
    for (const child of option.children) {
      if (child.photo && !child.time) {
        child.time = formatDate();
        child.user = user;
        child.open = 1;
      }

      setTimeAndUser(child, user);
    }
  }
}

export function getCheck(data_copy, check_id, top_level) {
  if (top_level) {
    for (const check of data_copy.checks) {
      if (check.id === check_id) {
        return check;
      }
    }
  }

  for (const check of data_copy.checks) {
    const inner_check = findCheck(check, check_id);
    if (inner_check) {
      return inner_check;
    }
  }

  return null;
}

export function getQuarter(d) {
  d = d || new Date(); // If no date supplied, use today
  var q = [1, 2, 3, 4];
  return q[Math.floor(d.getMonth() / 3)];
}

export function maintenanceCompareFn(a, b) {
  if (parseInt(a["dueInDays"]) === parseInt(b["dueInDays"])) {
    return 0;
  }
  return parseInt(a["dueInDays"]) < parseInt(b["dueInDays"]) ? -1 : 1;
}

export const INSPECTION_URL_TYPE_ROUTE = 1;
export const INSPECTION_URL_TYPE_API = 2;
export function getInspectionUrl(type, inspection, prefix, isFso = false) {
  if (type === INSPECTION_URL_TYPE_ROUTE) {
    return (
      prefix +
      "/wizard/" +
      inspection.type +
      "/" +
      inspection.id +
      "/" +
      (isFso ? "1" : inspection.operationId)
    );
  } else {
    return (
      "/api/inspections/" +
      inspection.type +
      "/" +
      inspection.id +
      "/" +
      (isFso ? "1" : inspection.operationId) +
      "/start"
    );
  }
}

export function setInspectionOffline(
  update_main_context,
  inspection_type,
  inspection_id
) {
  update_main_context((prev) => ({
    ...prev,
    inspections: prev.inspections
      ? {
          ...prev.inspections,
          [inspection_type]:
            prev.inspections[inspection_type] &&
            prev.inspections[inspection_type].length
              ? prev.inspections[inspection_type].map((x) => {
                  if (x.id === inspection_id) {
                    x.offline_exists = true;
                  }
                  return x;
                })
              : prev.inspections[inspection_type],
        }
      : prev.inspections,
  }));
}

export function formatDate() {
  var d = new Date(),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear(),
    hour = "" + d.getHours(),
    minute = "" + d.getMinutes(),
    second = "" + d.getSeconds();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  if (hour.length < 2) hour = "0" + hour;
  if (minute.length < 2) minute = "0" + minute;
  if (second.length < 2) second = "0" + second;

  return [year, month, day].join("-") + " " + [hour, minute, second].join(":");
}
